module.exports = __webpack_public_path__ + "static/img/banner_img_04.028d13b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/mobile/banner_img_04.png
// module id = BDSJ
// module chunks = 0